import { FC } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { selectProductStock } from '@telialt/utils/src/eshopSelectors';
import { withParams } from '@telialt/utils/src/helpers';

import { useCartQuery } from '../hooks/queries/useCartQuery';
import { getLocalizedStockShipmentDate } from '../ProductStockStatus/utils';
import { PreorderBannerWrapper } from './PreOrderBanner.styles';

type Props = {
    isUpsell?: boolean;
    isSticky?: boolean;
};

export const PreOrderBanner: FC<Props> = ({ isUpsell, isSticky }) => {
    const { t } = useTranslations();
    const { cart } = useCartQuery();

    const stock = selectProductStock(cart);

    const localizedStockShipmentDate = getLocalizedStockShipmentDate(stock);

    const text = isUpsell
        ? withParams(t['eshop.product_page.cart_box.preorder.upsell.text'], { date: localizedStockShipmentDate })
        : withParams(t['eshop.product_page.cart_box.preorder.banner.text'], { date: localizedStockShipmentDate });

    return <PreorderBannerWrapper $isSticky={isSticky}>{text}</PreorderBannerWrapper>;
};
